import { TabLayout } from "../layouts/TabLayout";
import { SotdaCommunityScreen } from "../redesign/live/CommunityScreen";

// 커뮤니티 탭 — 클로드디자인 community 시안(SotdaCommunityScreen).
// 글 목록 정적 시안. 봇 글 클릭 → /community/post/:id.
// design doc: 2026-05-22-sotda-ia-restructure §4 Phase D
export function CommunityPage() {
  return (
    <TabLayout page="community">
      <SotdaCommunityScreen />
    </TabLayout>
  );
}
